<template>
  <div class="w-[150px] h-[36px]">
    <b-form-group size="sm" class="w-[150px]">
      <b-button :id="`${id}`" variant="outline-secondary"
        class="w-full p-1 text-left d-flex justify-content-between align-items-center" style="height: 36px !important;"
        @click="popoverShow = !popoverShow">
        <span class="text-nowrap truncate text-sm">{{ selectedLabel }}</span>
        <img
          :src="popoverShow ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up-2.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'"
          alt="arrow" width="15px">
      </b-button>
      <b-popover :id="`${id}-list`" :target="`${id}`" placement="bottom" triggers="manual"
        :show.sync="popoverShow">
        <ul style="margin: -8px -10px -8px -10px;">
          <li v-for="(option, idx) in options" :key="idx">
            <b-button v-if="option.label" class="w-100 text-left" variant="light" @click="selectOption(option)">
              {{ option.label }}
            </b-button>
          </li>
        </ul>
      </b-popover>
    </b-form-group>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'

export default {
  name: 'RevenueDropdown',
  components: {
    BPopover,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: 'All Revenue',
    },
  },
  data() {
    return {
      popoverShow: false,
      selectedLabel: this.value,
      dateRange: '',
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const mainPopover = document.getElementById(`${this.id}-list`)
      const button = document.getElementById(`${this.id}`)
      const datePickPopover = document.querySelector('.daterangepicker')

      if (
        mainPopover && !mainPopover.contains(event.target)
        && button && !button.contains(event.target)
        && (!datePickPopover || !datePickPopover.contains(event.target))
      ) {
        this.popoverShow = false
      }
    },
    selectOption(option) {
      this.selectedLabel = option.label
      this.popoverShow = false
      this.$emit('change', option.value)
    },
    handleDateChange(value) {
      this.selectedLabel = 'Custom Range'
      this.popoverShow = false
      this.$emit('date-change', {
        startDate: value.startDate,
        endDate: value.endDate,
      })
    },
  },
}
</script>

<style>
.year-picker-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  border: 1px solid #ECE9F1;
  border-radius: 4px;
  padding: 0.4rem 1rem;
  background: white;
  cursor: pointer;
}
</style>
